<template>
  <div
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-click-outside="toggleItemOuter"
  >
    <div v-show="hasError" class="erorr-message">{{ errorMessage }}</div>
    <div
      class="lego-dropdown__title"
      :class="{ 'is-item-showing': isItemShowing }"
      @click="toggleItem"
    >
      <div class="lego-dropdown__selected" ref="widthDiv" :style="dropdownTitleStyle">
        <div v-lego-tooltip:ellipsis="textToolTip" style="display: flex">
          <span :style="styleTextSelected">
            <span style="text-overflow: ellipsis; width: 100%">{{ textSelected }}</span>
          </span>
          <span
            v-if="isMultiSelect"
            style="text-overflow: unset; min-width: max-content; margin-left: 3px"
            >{{ countSelected }}</span
          >
        </div>
      </div>

      <lego-icon-wrapper style="width: 18px; margin-left: 12px">
        <lego-icon class="lego-dropdown__icon" icon="expand_menu" size="12px" :style="caretStyle" />
      </lego-icon-wrapper>
    </div>
    <div class="lego-dropdown__downwrap" v-if="isItemShowing">
      <div class="lego-dropdown__tags">
        <NullWidget v-if="items == undefined || items.length === 0" style="min-height: 134px" />
        <div v-if="hasSearchField && items.length > 0" class="auto-complete__search-box">
          <lego-text-field
            ref="filterInput"
            :placeholder="searchPlaceholder || $t('label.all')"
            v-model="filterText"
            :isHideSpecialCharacter="true"
            searchable
            counter="100"
            :isCounter="false"
            @input="filterTextOnInput"
            :mutateInput="mutateInput"
          />
        </div>

        <div v-if="getFilterItems.length > 0" class="lego-dropdown__selectall-wrap">
          <div
            class="lego-dropdown__item lego-dropdown__selectall"
            v-if="!filterText"
            @click="clickSelectAll"
          >
            <lego-checkbox
              :indeterminate="selectAllChecked && selectAllCheckedIcon === 'indeterminate'"
              :checked="selectAllChecked"
              :checked-icon="selectAllCheckedIcon"
              @click="clickSelectAll"
              >{{ $t('label.all') }}
            </lego-checkbox>
          </div>
        </div>
        <span class="search-result" v-if="filterText">{{ searchResult }}</span>
        <c-scroll
          :style="
            getFilterItems.length > 0 && items != undefined && items.length > 0
              ? { maxHeight: getFilterItems.length > 9 ? '275px' : 'auto' }
              : ''
          "
        >
          <div
            v-if="getFilterItems.length === 0 && items != undefined && items.length > 0"
            class="no-result"
          >
            {{ t('label.noSearchResult') }}
          </div>

          <div class="lego-dropdown__items">
            <div
              class="lego-dropdown__item"
              :class="{ 'item-checked': item.check }"
              v-for="(item, idx) in getFilterItems"
              :key="idx"
              @click="onClickItem(item)"
            >
              <div v-if="item.key !== null && item.value !== null" class="lego-dropdown__label">
                <lego-checkbox
                  :value="item"
                  :checked="selected"
                  @click="onClickItem(item)"
                  :valueKey="valueKey"
                >
                  <em
                    class="ellipsis"
                    v-lego-tooltip:ellipsis="getTagText(item, true)"
                    v-html="getTagText(item)"
                  >
                  </em>
                </lego-checkbox>
              </div>
            </div>
          </div>
        </c-scroll>
        <div class="lego-dropdown__apply-wrap">
          <div class="lego-dropdown__apply lego-dropdown__apply_pos" v-show="applyBtn">
            <lego-button @click="onApplyClick">{{ $t('button.apply') }}</lego-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoDropdown from '@/lego-component/components/element/legoDropdown/legoDropdown.vue';
import cScroll from '../../cmp/cScroll/cScroll.vue';
import NullWidget from '@/containers/widget/components/NullWidget.vue';

export default {
  mixins: [i18nMixin],
  name: 'scpm-dropdown-v3',
  components: { cScroll, NullWidget },
  extends: legoDropdown,
  emits: ['tag-input', 'update:modelValue'],
  props: {
    modelValue: {
      type: [Array, String],
      default: () => []
    },
    applyBtn: { type: Boolean, default: false },
    selectAll: { type: Boolean, default: false },
    mutateInput: { type: Function, default: null },
    hasSearchField: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: '' },
    showOnlyKey: { type: Boolean, default: false },
    isChangeTextShow: { type: Boolean, default: false },
    isTarget: { type: Boolean, default: false },
    maxSelect: { type: [Number, String], default: '' },
    messageErrorMaxSelect: { type: String, default: '' },
    isCustomComMonConfig: { type: Boolean, default: false },
    isStaticType: { type: Boolean, default: false },
    isEventFiltering: { type: Boolean, default: false },
    valueKey: { type: String, default: '' }
  },
  data() {
    return {
      filterText: '',
      selected: [],
      prevSelected: [],
      isShowTooltip: false,
      textToolTip: '',
      textSelected: this.$t('label.all'),
      countSelected: '',
      isMultiSelect: false,
      hasError: false,
      errorMessage: '',
      tmpSelected: [],
      searchResult: ''
    };
  },
  computed: {
    getFilterItems() {
      let findItems = [];
      if (this.selectAll) {
        this.searchResult = '';
      }
      if (this.items != undefined) {
        for (let i = 0; i < this.items.length; i++) {
          let _item = this.items[i];
          _item['check'] = false;
          if (this.filterText && 0 < this.filterText.length) {
            if (
              this.isTarget &&
              _item['value'].toLowerCase().includes(this.filterText.toLowerCase())
            ) {
              _item['idx'] = i;
              findItems.push(_item);
            } else if (
              !this.isTarget &&
              ((_item['key'] &&
                _item['key'].toLowerCase().includes(this.filterText.toLowerCase())) ||
                (_item['value'] &&
                  _item['value'].toLowerCase().includes(this.filterText.toLowerCase())))
            ) {
              _item['idx'] = i;
              findItems.push(_item);
            }
          } else {
            _item['idx'] = i;
            findItems.push(_item);
          }
        }
      }

      if (findItems.length) {
        this.searchResult = this.$t('label.searchResultParam', ['(' + findItems.length + ')']);
      }

      if (!Array.isArray(this.selected)) {
        this.selected = [];
      }

      // 체크여부
      for (let i = 0; i < findItems.length; i++) {
        let _item = findItems[i];

        let selectedIndex = -1;

        if (this.isCustomComMonConfig) {
          selectedIndex = this.selected.findIndex((row) => row.value === _item.value);
        } else {
          selectedIndex = this.selected.findIndex((row) => row.key === _item.key);
        }

        if (-1 < selectedIndex) {
          _item['check'] = true;
        }

        if (this.isCustomComMonConfig) {
          this.selected.forEach((item) => {
            if (item.value.toString() === _item.value.toString() && item.idx != _item.idx) {
              item.idx = _item.idx;
            }
          });
        }
      }
      return findItems;
    },
    dropdownTitleStyle() {
      if (this.isCustomComMonConfig || this.isStaticType) {
        this.getSelectedItemText();
      }

      if (this.selected.length === 0) {
        this.textSelected = this.$t('label.all');
        this.countSelected = '';
        this.isShowTooltip = false;

        return { color: '#a5a7ad' };
      } else {
        return { color: '#000' };
      }
    },
    selectAllChecked() {
      return this.selected.length > 0;
    },
    selectAllCheckedIcon() {
      if (this.hasSearchField) {
        return this.getFilterItems.every((item) => item.check === true)
          ? 'checked'
          : 'indeterminate';
      }
      return this.selected.length === this.items.length ? 'checked' : 'indeterminate';
    },
    styleTextSelected() {
      let style = {};

      style['width'] = 'auto';
      style['text-overflow'] = 'ellipsis';
      style['max-width'] = '100%';

      return style;
    }
  },
  watch: {
    isItemShowing() {
      if (this.applyBtn && this.isItemShowing) {
        this.prevSelected = this.selected.slice();
      }
    },
    modelValue() {
      if (!_.isEqual(this.selected, this.modelValue)) {
        this.selected = this.modelValue.slice();
      }
    }
  },
  mounted() {
    this.selected = this.modelValue.slice();
  },
  methods: {
    filterTextOnInput() {
      this.filterText = this.filterText.trim();
    },
    getSelectedItemText() {
      this.isShowTooltip = false;

      if (this.selected.length === 0 || this.selected.length === this.items.length) {
        this.textSelected = this.$t('label.all');
        this.countSelected = '';
      } else {
        let itemText = [];
        let firstIdx = 0;
        let idx = 0;
        const count = this.selected.length;

        if (this.isEventFiltering) {
          this.items.forEach((_item) => {
            this.selected.forEach((item) => {
              if (item.value.toString() === _item.value.toString() && item.idx != _item.idx) {
                item['idx'] = _item.idx;
                item['value'] = _item.value.toString();
                item['ip'] = _item.ip;
                item['tag'] = _item.tag;
                item['key'] = _item.key;
                item['version'] = _item.version;
                _item['check'] = true;
              }
            });
          });
        }

        if (typeof this.itemText === 'function') {
          itemText.push(this.itemText(item));
        } else if (this.isCustomComMonConfig) {
          itemText.push(this.selected[0].text);
        } else {
          if (this.showOnlyKey) {
            if (this.isChangeTextShow) {
              itemText.push(this.selected[0].value);
            } else {
              itemText.push(this.selected[0].key);
            }
          } else {
            itemText.push(
              this.selected[0].key.concat(
                this.selected[0].value ? `:${this.selected[0].value}` : ''
              )
            );
          }
        }

        this.textToolTip = itemText.toString();
        this.textSelected = itemText.toString();
        this.countSelected = '';

        if (count >= 2) {
          this.isMultiSelect = true;
          this.textToolTip = this.textToolTip + ' ' + this.$t('label.andSelected', [count - 1]);
          this.countSelected = this.$t('label.andSelected', [count - 1]);
        } else {
          this.isMultiSelect = false;
          this.countSelected = '';
        }

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = getComputedStyle(document.body).font;
        let widthDiv = this.$refs.widthDiv.clientWidth;
        let widthSpan = Math.ceil(context.measureText(this.textToolTip).width);

        if (widthSpan > widthDiv) {
          this.isShowTooltip = true;
        }
      }
    },
    getTagText(item, isTooltip = false) {
      let itemText = '';
      if (item.value === undefined) {
        itemText = item.key;
      } else {
        itemText = item.key + ':' + item.value;
      }

      if (this.showOnlyKey) {
        itemText = item.value;
      }

      if (this.isCustomComMonConfig) {
        itemText = item.text;
      }

      itemText = this.$util.escapeHTML(itemText);

      if (this.filterText === '') return itemText;

      const regex = this.$util
        .escapeHTML(this.filterText)
        .replace(/[!@#$%^&*()+=\-[\]\\';,./{}|":<>?~_]/g, '\\$&');
      return isTooltip
        ? itemText
        : itemText.replace(
            new RegExp(regex, 'ig'),
            (w) => "<span style='color:#2c59d9'>" + w + '</span>'
          );
    },
    onClickItem(item) {
      let indexInSelected = -1;

      if (this.isCustomComMonConfig) {
        indexInSelected = this.selected.findIndex((itemAll) => itemAll.value === item.value);
      } else {
        indexInSelected = this.selected.findIndex((itemAll) => itemAll.key === item.key);
      }

      if (indexInSelected > -1) {
        this.selected.splice(indexInSelected, 1);
      } else {
        if (this.maxSelect && this.selected.length >= this.maxSelect) {
          this.hasError = true;
          this.errorMessage = this.messageErrorMaxSelect;
          return;
        }

        this.selected.push({ ...item, check: true });
      }

      this.getSelectedItemText();

      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected.slice());
      }
      this.$emit('update:modelValue', this.selected.slice());
    },
    toggleItem() {
      this.resetSelected();
      this.isItemShowing = !this.isItemShowing;
    },
    toggleItemOuter() {
      this.resetSelected();
      this.isItemShowing = false;
    },
    resetSelected() {
      if (this.applyBtn && this.isItemShowing) {
        this.selected = this.prevSelected.slice();
      }
    },
    onApplyClick() {
      this.$emit('tag-input', this.selected.slice());
      this.isItemShowing = false;
    },
    clickSelectAll() {
      const ableItem = this.items.filter((item) => {
        return !item.disabled;
      });

      if (this.maxSelect && ableItem.length > this.maxSelect) {
        this.hasError = true;
        this.errorMessage = this.messageErrorMaxSelect;
        return;
      }

      // Uncheck
      if (this.selectAllCheckedIcon == 'checked') {
        this.getFilterItems.map((item) => {
          let indexSelectedInAll = -1;

          if (!this.isCustomComMonConfig) {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.key === itemAll.key);
          } else {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.value === itemAll.value);
          }

          indexSelectedInAll > -1 && this.selected.splice(indexSelectedInAll, 1);
        });
      } else {
        this.getFilterItems.map((item) => {
          let indexSelectedInAll = -1;

          if (this.isCustomComMonConfig) {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.value === itemAll.value);
          } else {
            indexSelectedInAll = this.selected.findIndex((itemAll) => item.key === itemAll.key);
          }

          indexSelectedInAll === -1 && this.selected.push({ ...item, check: true });
        });
      }

      this.getSelectedItemText();

      if (!this.applyBtn) {
        this.$emit('tag-input', this.selected.slice());
      }
      this.$emit('update:modelValue', this.selected.slice());
    },
    clearInputSearch() {
      this.filterText = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.search-result {
  padding-left: 12px;
  font-size: 12px;
  color: #999999;
}

.no-result {
  cursor: default;
  padding: 25px 0;
  text-align: center;
  font-size: 11px;
  color: #858585;
}

.auto-complete__search-box {
  padding: 12px 12px 0px 12px;
}

.erorr-message {
  font-size: 12px;
  color: #fc434e;
}

.lego-dropdown {
  min-width: 80px;
  width: 100%;

  &__title {
    border-radius: 2px;

    &.is-item-showing {
      border-color: $lego-dropdown__title__border--focus;
    }

    .lego-dropdown__selected {
      display: block;
      line-height: 30px;
      width: calc(100% - 24px);
      color: #a5a7ad;

      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }

    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--borderless {
    width: auto;
    min-width: auto;

    .lego-dropdown__title {
      border: 0 !important;

      .lego-dropdown__selected {
        flex-grow: 1;
      }
    }

    &.lego-dropdown--disabled {
      .lego-dropdown__title {
        background: none !important;
      }
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;

    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--small {
    min-width: $lego-dropdown__min-width--small;

    .lego-dropdown__title-icon {
      .lego-dropdown__icon {
        font-size: 10px;
      }
    }
  }
}

::v-deep .lego-button--border.lego-button--default {
  font-weight: 700;
  background-color: #364fc7;
  border-color: #364fc7;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  border-radius: 2px;
  height: 24px;
  min-width: 70px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    background-color: #2b3f9f;
    border-color: #2b3f9f;
  }
}

::v-deep .lego-dropdown__downwrap {
  width: 100%;
}

.lego-dropdown__tags {
  // position: relative;
  // padding: 0 10px;
  background-color: #ffffff;
  border: 1px solid #364fc7;
}

::v-deep .lego-dropdown__item {
  padding: 0 12px 0 12px;

  &.item-checked,
  &:hover {
    background-color: #eff1fb;

    .lego-dropdown__label {
      .lego-checkbox__label {
        color: #2f3237;
        font-weight: 400;
      }
    }
  }
}

::v-deep .lego-dropdown__selectall {
  display: block !important;
  border: 0;
  border-bottom: 1px solid #e4e5e7;
  line-height: 24px;
  min-height: 34px;
  max-height: 48px;

  .lego-dropdown__item .lego-checkbox__checked + .lego-checkbox__label,
  .lego-checkbox__label {
    color: #2f3237 !important;
    font-weight: 700;
    padding-top: 1px;
  }

  &:hover {
    background-color: #eff1fb !important;
  }
}

::v-deep .lego-dropdown__items {
  // margin-bottom: 42px;
  max-height: initial;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.lego-dropdown__selectall-wrap {
  padding: 0 0px;

  .lego-dropdown__item {
    &:hover {
      background-color: transparent;
    }
  }
}

.lego-dropdown__apply-wrap {
  padding: 0 10px;
}

// .lego-dropdown__apply-wrap {
//   position: absolute;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: #fff;
// }
::v-deep .lego-dropdown__apply {
  border: 0;
  border-top: 1px solid #a5a7ad;
}

::v-deep .lego-button--default:not(.lego-button--loading):hover {
  background-color: #2b3f9f !important;
}

::v-deep .lego-checkbox__label {
  display: block;
  width: calc(100% - 10px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #2f3237;
  padding-top: 1px;

  em {
    display: block;
    font-style: normal;
    @include ellipsis;
  }
}

::v-deep .lego-dropdown__label {
  flex: 0 1 auto;
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

::v-deep .lego-checkbox {
  display: block;
  flex: 0 1 auto;
  align-items: flex-start;
  padding: 5px 0 0 15px;
}

::v-deep .lego-checkbox__icon {
  position: absolute;
  top: 8px;
  left: 0;
}
</style>
